import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  coverImage: string;
  rating: number;
  views: number;
  status: string;
  tags: string[];
  categoryName: string;
}

export default function ComicCard({ id, title, author, coverImage, rating, views, status, tags, categoryName }: ComicCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[400/560] mb-3">
        <img
          src={coverImage}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md text-xs font-medium bg-accent-500 text-background-50">
          {status}
        </span>
        <div className="absolute bottom-2 left-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="flex items-center gap-1 text-background-50 text-xs">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            <span>{rating}</span>
            <span className="mx-1">·</span>
            <i className="ri-eye-line text-xs"></i>
            <span>{formatViews(views)}</span>
          </div>
        </div>
      </div>
      <h3 className="text-sm font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors mb-1">
        {title}
      </h3>
      <div className="flex items-center gap-2 text-xs text-foreground-500">
        <span>{author}</span>
        <span>·</span>
        <span>{categoryName}</span>
      </div>
      <div className="flex flex-wrap gap-1 mt-2">
        {tags.slice(0, 2).map((tag) => (
          <span
            key={tag}
            className="px-2 py-0.5 rounded-md text-[10px] bg-secondary-100 text-secondary-700"
          >
            {tag}
          </span>
        ))}
      </div>
    </Link>
  );
}